/**
 *
 * @param px pixel value to be converted to rem
 * @param base base font-size for the conversion(defaults to 16)
 */
const rem = (px: number, base: number = 16) => {
  return `${px / base}rem`;
};

export default rem;
